import type { AppShellFactory, AppShellMainProps, AppShellNavbarProps, AppShellProps } from "@mantine/core";
import { AppShellSecondaryNavbar, AppShellMain } from "./app-shell";
import { AppShellNavbarFactory } from "@mantine/core/lib/components/AppShell/AppShellNavbar/AppShellNavbar";
import { AppShellMainFactory } from "@mantine/core/lib/components/AppShell/AppShellMain/AppShellMain";

export interface CustomAppShellFactory extends Omit<AppShellFactory, "staticComponents"> {
    props: IProps;
    staticComponents: Omit<AppShellFactory["staticComponents"], "Main"> & {
        SecondaryNavbar: typeof AppShellSecondaryNavbar;
        Main: typeof AppShellMain;
    };
}

export interface IProps extends AppShellProps {
    secondaryNavbar?: { width: 360 };
}

export interface CustomAppShellSecondaryNavbarFactory extends AppShellNavbarFactory {
    props: ISecondaryNavbarProps;
}

export interface ISecondaryNavbarProps extends AppShellNavbarProps {
    readonly disableScroll?: boolean;
}

export const PADDING_TOP_PRESETS = ["default", "header", "none"] as const;
export type PaddingTopPreset = (typeof PADDING_TOP_PRESETS)[number];

export interface IAppShellMainProps extends Omit<AppShellMainProps, "pt"> {
    readonly pt?: PaddingTopPreset | AppShellMainProps["pt"];
}

export interface CustomAppShellMainFactory extends Omit<AppShellMainFactory, "props"> {
    props: IAppShellMainProps;
}
